if (!window.cc_Renderer) {
	window.cc_Renderer = {};
}

(function () {
	"use strict";

	cc_Renderer.PROPERTY_DECORATOR = "Decorator";
	cc_Renderer.PROPERTY_DECORATOR_USE_DECIMAL_PERCENTAGE = "UseDecimalPercentage"
	cc_Renderer.PROPERTY_PLACEHOLDER = "Placeholder";
	cc_Renderer.PROPERTY_HELP_TEXT = "HelpText";
	cc_Renderer.PROPERTY_STYLE = "Style"; // ButtonGroup, Password
	cc_Renderer.PROPERTY_LAYOUT = "Layout"; // Horizontal
	cc_Renderer.PROPERTY_LAYOUT_TEXT_POSITION = "TextPosition"; // Full, Fixed, Floating
	cc_Renderer.PROPERTY_LAYOUT_COLUMNS = "Columns"; // 1 - 12
	cc_Renderer.PROPERTY_LAYOUT_NEW_ROW = "NewRow"; // true
	cc_Renderer.PROPERTY_HEIGHT = "Height"; // 200px
	cc_Renderer.PROPERTY_DISABLED_OUTPUT = "DisabledOutput";
	cc_Renderer.PROPERTY_ENTERED_REGEX_MATCH = "EnteredRegexMatch";
	cc_Renderer.PROPERTY_ENTERED_REGEX_SUBSTITUTION = "EnteredRegexSubstitution";

	cc_Renderer.enableScrollToCaptureUserAttention = true;
	cc_Renderer.fieldChangeAwaitingModelWrite = [];

	cc_Renderer.startInit = function () {
		$('#cloudcase-form').empty().append(cc_EntityIntegration.createDefaultScreen()).hide();

		// clean up previous state because the modal interview dialog can be opened many times on the same url
		cc_Renderer.lastQuestionChangedScrollTop = null;
		cc_Renderer.lastScrolledToSectionDivId = null;
	};

	cc_Renderer.startQuickfillInit = function () {
		$('#cloudcase-form').empty().append(cc_View.createQuickfillDefaultScreen()).hide();
	};

	cc_Renderer.completeInit = function () {
		$('#cloudcase-form').show();
	};

	cc_Renderer.render = function (pageToRender, response, triggerType, focusedQuestionId, isUserDriven, isExplictSave, triggeringQuestionId, manuallySelectedPageId, enableMoveToRelativePage, quickfill) {
		var result = {};
		result.questionsToAttached = [];
		result.newlyShownQuestions = [];

		if(response.next && response.next.length > 0){
			$.each(response.next, function () {
				result.newlyShownQuestions.push(this.id);
			});
		}

		if(response.revealed && response.revealed.length > 0){
			$.each(response.revealed, function () {
				result.newlyShownQuestions.push(this);
			});
		}

		$.each(cc_Model.questionsToBeRerendered, function () {
			var question = cc_Model.anyLevelQuestionMap[this];

			if (quickfill) {
				if (quickfill.questionId == question.id) {
					result.questionsToAttached.push(question.id);
				}
			} else {
				if (cc_Config.enableLazyQuestionRendering === false || pageToRender == question.page.id) {
					result.questionsToAttached.push(question.id);
				}
			}
		});

		result.triggerType = triggerType;
		result.isUserDriven = isUserDriven;
		result.isExplictSave = isExplictSave;
		result.focusedQuestionId = focusedQuestionId;
		result.triggeringQuestionId = triggeringQuestionId;
		result.quickfill = quickfill;
		result.isInterviewComplete = cc_Model.isInterviewComplete === true || false;
		result.treatInterviewAsCompletedOnLoad = cc_Model.treatInterviewAsCompletedOnLoad || false;
		result.isFirstRequest = cc_Model.isFirstRequest;
		result.hasInvalidQuestions = response.invalid && response.invalid.length > 0;
		result.invalidQuestionsOnSelectedPage = cc_Model.getSelectedPageQuestionsForReferences(response.invalid);
		result.newlyShownQuestionsOnSelectedPage = cc_Model.getSelectedPageQuestionsForReferences(cc_Model.convertToQuestionReferences(result.newlyShownQuestions));
		result.hasInvalidOrNewlyShownQuestionsOnSelectedPage = result.invalidQuestionsOnSelectedPage.length > 0 || result.newlyShownQuestionsOnSelectedPage.length > 0;
		result.pageToShow = cc_Renderer.determinePageToShow(result, pageToRender, triggerType, isUserDriven, manuallySelectedPageId, enableMoveToRelativePage);

		var allowRendering = result.pageToShow && pageToRender == result.pageToShow.id;
		var hasQuestionsToAttached = result.questionsToAttached && result.questionsToAttached.length > 0;
		var hasNewlyShownQuestions = result.newlyShownQuestions && result.newlyShownQuestions.length > 0;

		var attachedConcealedQuestions = [];
		if(allowRendering == true && hasQuestionsToAttached == true){
			$.each(result.questionsToAttached, function () {
				var question = cc_Model.anyLevelQuestionMap[this];

				if(question){ // question could be on a restricted page
					// concealed can include:
					// -> questions flagged as concealed via response.concealed OR
					// -> any level next questions with concealed = true, this can occur when resuming a stateful session
					if(question.concealed == true){
						attachedConcealedQuestions.push(question.id);
					}

					// this will render both shown and concealed questions. they will be hidden later
					cc_Renderer.attachQuestion(question, cc_View.findQuestionPanelById(question.id).length == 0);

					cc_Util.removeElement(cc_Model.questionsToBeRerendered, question.id);
				}
			});

			// ensure any concealed pages or sections are shown when newly attached questions are added
			cc_Renderer.updatePageAndSectionVisibilityForRevealed(result.questionsToAttached);
		}

		if(pageToRender){
			cc_Renderer.hideConcealedQuestions(pageToRender);
		}

		// compile an array of all concealed questions via response.concealed and response.next
		var allConcealedQuestions = attachedConcealedQuestions;
		if(response.concealed && response.concealed.length > 0){
			allConcealedQuestions = allConcealedQuestions.concat(response.concealed);
		}

		if(allConcealedQuestions && allConcealedQuestions.length > 0){
			cc_Renderer.updatePageAndSectionVisibilityForConcealed(allConcealedQuestions);
		}

		if(response.revealed && response.revealed.length > 0){
			cc_Renderer.updatePageAndSectionVisibilityForRevealed(response.revealed);
		}

		if(hasNewlyShownQuestions == true){
			cc_Renderer.attachPageWarnings(result.newlyShownQuestions);
		}

		// Remove question text styling to keep consistent
		////////////////////////////////////////////////////////////////////////////////////////
		//             UI_CUSTOM_CHANGES - to make merging on upgrades easier, please update as you make changes:
		//             1. 'style' removed from 'questionText'
		////////////////////////////////////////////////////////////////////////////////////////

		// $('.questionText *').removeAttr('style');

		result.isRendered = allowRendering;

		return result;
	};

	cc_Renderer.attachUserExperienceExtensions = function(extensions) {
		if (Array.isArray(extensions)) {
			extensions.forEach(function(extension) {
				cc_Extension.snapshotMethods(extension.extendMethods);
				if (!cc_Renderer.styleExistsInHead(extension.id)) {
					cc_Renderer.attachStyleToHead(extension.id, extension.appearance);
				}
				if (!cc_Renderer.scriptExistsInHead(extension.id)) {
					cc_Renderer.attachScriptToHead(extension.id, extension.behavior);
				}
			});
		}
	};

	cc_Renderer.styleExistsInHead = function(id) {
		return !!$("style." + id).length;
	}

	cc_Renderer.attachStyleToHead = function(id, style) {
		$('head').append("<style class='extension " + id + "'>" + style + "</style>");
	};

	cc_Renderer.scriptExistsInHead = function(id) {
		return !!$("script." + id).length;
	}

	cc_Renderer.attachScriptToHead = function(id, script) {
		//	TODO see if its possible to merge with external widget's add to head
		$('head').append("<script class='extension " + id + "' type='text/javascript'>" + script + "</script>");
	};

	cc_Renderer.attachPageWarnings = function(questionsToAttached){
		var viewedPagesWithNewlyAttachedQuestions = [];

		$.each(questionsToAttached, function () {
			var question = cc_Model.anyLevelQuestionMap[this];
			var page = cc_Model.topLevelPagesMap[question.page.id];

			if(page && page.viewed && cc_Model.getSelectedPageId() != page.id && !cc_Util.containsElement(viewedPagesWithNewlyAttachedQuestions, page.id)){
				viewedPagesWithNewlyAttachedQuestions.push(page.id);
			}
		});

		$.each(viewedPagesWithNewlyAttachedQuestions, function () {
			cc_Renderer.attachPageWarning(this);
		});
	};

	cc_Renderer.hideConcealedQuestions = function(page){
		$('#' + cc_View.getPageDivId(page) + ' .concealed').hide();
	};

	cc_Renderer.determinePageToShow = function (result, currentSelectedPage, triggerType, isUserDriven, manuallySelectedPageId, enableMoveToRelativePage) {
		if(currentSelectedPage === null && cc_Model.getFirstPageRequiringAttention()){
			currentSelectedPage = cc_Model.getFirstPageRequiringAttention().id;
		}

		var pageIdToShow = currentSelectedPage;

		if(isUserDriven == true){
			var isEditInterviewMode = cc_Model.interviewMode === cc_Model.INTERVIEW_MODE_EDIT;

			if(triggerType === "NEXT" && enableMoveToRelativePage == true){
				pageIdToShow = cc_Model.getNextPageId(currentSelectedPage);

			}else if(triggerType === "PREVIOUS" && enableMoveToRelativePage == true){
				pageIdToShow = cc_Model.getPreviousPageId(currentSelectedPage);
			}

			if(manuallySelectedPageId && cc_Model.topLevelPagesMap[manuallySelectedPageId]){
				// moving manuallySelectedPageId check here since NEXT and PREVIOUS are never used with manuallySelectedPageId.
				// manuallySelectedPageId should only be used for page selection, quickfill, or open-interview
				pageIdToShow = manuallySelectedPageId;

			}else if(isEditInterviewMode == true && result.isExplictSave == true && (result.isReadyToFinish == true || result.hasInvalidOrNewlyShownQuestionsOnSelectedPage == true)){
				pageIdToShow = currentSelectedPage;

			}else if(isEditInterviewMode == true && cc_Model.isInterviewInProgress() == false && result.hasInvalidOrNewlyShownQuestionsOnSelectedPage == true){
				pageIdToShow = currentSelectedPage;

			}else if (enableMoveToRelativePage == true && cc_Model.doesPageHaveQuestions(pageIdToShow) == false){
				pageIdToShow = currentSelectedPage;
			}
		}

		return cc_Model.topLevelPagesMap[pageIdToShow];
	};

	cc_Renderer.showPage = function (page, result) {
		if(page){
			page.viewed = true;
			cc_Model.selectedPage = page;
			cc_Model.isFirstPageSelected = (cc_Model.selectedPage.id == cc_Model.getFirstPage().id);
			cc_Model.isLastNonRestrictedPageSelected = (cc_Model.selectedPage.id == cc_Model.getLastNonRestrictedPage().id);
			cc_Model.isRestrictedPageSelected = cc_Model.selectedPage.restricted == true;
			cc_Model.isWritableRestrictedPageSelected = (cc_Model.selectedPage.restricted == true && cc_Model.selectedPage.readOnly == false);

			// warnings are used to ensure the user knows that something has changed on the page.
			// therefore when a page is shown its warnings should be removed
			cc_Renderer.detachPageWarning(page.id);

			cc_Renderer.selectPageNavigatorItem(page.id);

			var selectedPageDivId = cc_View.getPageDivId(page.id);

			var detachErrorCallback = function(){
				cc_Renderer.detachError($(this).parent().find('[cc-field]').attr('cc-field'));
			};

			$('#' + selectedPageDivId + ' > * input[cc-field][type=text], ' +
				'#' + selectedPageDivId + ' > * input[cc-field][type=number], ' +
				'#' + selectedPageDivId + ' > * button[cc-field][type=number], ' +
				'#' + selectedPageDivId + ' > * select, ' +
				'#' + selectedPageDivId + ' > * textarea')
				.on('focus', detachErrorCallback);

			// checkbox does not trigger focus event on check or uncheck & radio buttons, file input and buttons loose focus when error message is detached
			$('#' + selectedPageDivId + ' > * input[type=checkbox], ' +
				'#' + selectedPageDivId + ' > * input[type=radio], ' +
				'#' + selectedPageDivId + ' > * input[type=file], ' +
                '#' + selectedPageDivId + ' > * .multiAnswerGroup[cc-group-question-id] label, ' +
				'#' + selectedPageDivId + ' > * input[type=button]')
				.on('click', detachErrorCallback);

			cc_Renderer.updateSubQuestionVisiblity(selectedPageDivId);

			$('#' + selectedPageDivId).addClass("viewed").show();

			cc_UI.selectAccordionPage(page.id);

			cc_Renderer.attachFieldChangeListeners();

			// process all new errors
			var hasNewErrors = result.response.invalid && result.response.invalid.length > 0;
			var allNewErrorsMap = {};

			if (hasNewErrors === true){
				$.each(result.response.invalid, function(){
					allNewErrorsMap[this.id] = this;
				});
			}

			// when the user triggered the page to be show then attach all errors
			if(result.isUserDriven == true && hasNewErrors === true){
				cc_Renderer.attachNewErrors(result.response.invalid);

				if(result.isFirstRequest == false){
					cc_Renderer.flashErrors();
				}

			// when a question change triggered the page to be shown only update the affected question
			}else if(result.triggeringQuestionId){
				if(hasNewErrors === true){
					$.each(result.response.invalid, function () {
						// update triggering question error by removing old and attaching new
						if(result.triggeringQuestionId == this.id){
							cc_Renderer.detachError(this.id);
							cc_Renderer.attachError(this.id, this.message, "server");
						}
					});
				}
			}

			// remove errors which previously existed but do not now (ie errors which have been corrected)
			if (cc_Model.allErrorsMap){
				$.each(cc_Model.allErrorsMap, function(){
					if(allNewErrorsMap[this.id] == null){
						cc_Renderer.detachError(this.id);
					}
				});
			}

			// all new errors become the current errors
			cc_Model.allErrorsMap = allNewErrorsMap;

			cc_Renderer.refreshPageWizard();
			cc_Model.handlePageShown();

			if(result.isUserDriven == true){
				cc_Renderer.detachPageCompletionIcons(page.id);
				cc_Model.updatePageCompletionStatuses();

				$.each(cc_Model.topLevelPagesMap, function(){
					if(this.completed == true){
						cc_Renderer.attachPageCompletionIcons(this.id);
					}
				});
			}

            $('[data-toggle="tooltip"]').tooltip();

			cc_Renderer.scrollToCaptureUserAttention(result);

			cc_Renderer.enablePageFolding();

			if(cc_EntityIntegration.onPostShowPage){
				cc_EntityIntegration.onPostShowPage(page);
			}
		}
	};

	cc_Renderer.selectPageNavigatorItem = function (pageId) {
		var toBeUnselectedPageNavigatorItem = cc_UI.currentlySelectedPage();
		toBeUnselectedPageNavigatorItem.removeClass('selected');
		toBeUnselectedPageNavigatorItem.find("i.activeEditIcon").remove();
		toBeUnselectedPageNavigatorItem.find("i.placeholderIcon").remove();

		if (toBeUnselectedPageNavigatorItem.find("i").length == 0) {
			toBeUnselectedPageNavigatorItem.prepend(cc_View.createPageNavigatorPlaceholderIcon());
		}

		$('#' + cc_View.getPageNavigatorItemId(pageId)).addClass('selected');
		if ($('#' + cc_View.getPageNavigatorItemId(pageId) + ' i').length == 0) {
			$('#' + cc_View.getPageNavigatorItemId(pageId)).prepend(cc_View.createPageNavigatorActiveEditIcon());

		}
	}

	cc_Renderer.attachActiveEditIcon = function(pageId) {
		if ($('#' + cc_View.getPageNavigatorItemId(pageId)).hasClass('selected') && $('#' + cc_View.getPageNavigatorItemId(pageId) + ' i').length == 0) {
			$('#' + cc_View.getPageNavigatorItemId(pageId)).prepend(cc_View.createPageNavigatorActiveEditIcon());
		}
	}

	cc_Renderer.updateSubQuestionVisiblity = function (selectedPageDivId) {
		// call all change listeners too so that sub questions are refreshed
		$('#' + selectedPageDivId + ' input, #' + selectedPageDivId + ' select, #' + selectedPageDivId + ' textarea').change();
	}

	cc_Renderer.updatePageAndSectionVisibilityForConcealed = function (questions) {
		$.each(questions, function(){
			var question = cc_Model.anyLevelQuestionMap[this];

			if(question){ // question could be on a restricted page
				var sectionName = cc_Model.getSectionName(question);

				if (cc_Model.doesSectionHaveQuestions(question.page.id, sectionName) == false) {
					$('#' + cc_View.getSectionFieldsetId(question.page.id, sectionName)).hide();
				}

				if (cc_Model.doesPageHaveQuestions(question.page.id) == false) {
					cc_Model.updatePageVisibility(question.page.id, false);

					$('#' + cc_View.getPageNavigatorItemId(question.page.id)).hide();
					$('#' + cc_View.getPageDivId(question.page.id)).hide();
				}
			}
		});
	};

	cc_Renderer.updatePageAndSectionVisibilityForRevealed = function (questions) {
		$.each(questions, function(){
			var question = cc_Model.anyLevelQuestionMap[this];

			if(question){ // question could be on a restricted page
				var sectionName = cc_Model.getSectionName(question);

				if (cc_Model.doesSectionHaveQuestions(question.page.id, sectionName) == true) {
					$('#' + cc_View.getSectionFieldsetId(question.page.id, sectionName)).show();
				}

				if (cc_Model.doesPageHaveQuestions(question.page.id) == true) {
					cc_Model.updatePageVisibility(question.page.id, true);

					$('#' + cc_View.getPageNavigatorItemId(question.page.id)).show();
					$('#' + cc_View.getPageDivId(question.page.id)).show();
				}
			}
		});
	};

	cc_Renderer.attachQuestion = function (question, isNew) {
		var sectionName = cc_Model.getSectionName(question);
		var sectionDivId = cc_View.getSectionDivId(question.page.id, sectionName);

		// we are dealing with a new section so lets add it first
		if ($('#' + sectionDivId).length == 0) {
			cc_Renderer.addNewSection(question, sectionName);
		}

		var hasExternalWidgets = cc_Renderer.hasExternalWidgets(question);

		// ensure all head scripts are added
		var externalWidgetsAddedToHead = []; // this acts as a cache of scripts have have been added to head
		cc_Renderer.applyExternalWidgetAddToHeadFunction(question, externalWidgetsAddedToHead);

		// logic to ensure all widgets are ready to render
		if(hasExternalWidgets === true){

			// this will manage time to ensure that the add to head script download is not being blocked by this thread
			cc_Renderer.renderQuestionAfterExternalWidgetsAreReadyToRender(question, function(){

				// question is ready to be rendered
				cc_Renderer.renderQuestion(question, isNew, sectionDivId);

				// support for VueJS2 widget - start
				if (cc_ExternalWidgetPlugin.VueJS2 && cc_ExternalWidgetPlugin.VueJS2._isVueJSExternalWidget(question)) {
					cc_Util.log("cc_Renderer.attachQuestion(): " + question.id + " setting initial question state");
					cc_ExternalWidgetPlugin.VueJS2._updateEnteredValue(question.id, question.entered);
					cc_ExternalWidgetPlugin.VueJS2._updateDisabledValue(question.id, question.disabled);
					cc_ExternalWidgetPlugin.VueJS2._updateTextValue(question.id, question.text);
				}
				// support for VueJS2 widget - end
			});

		}else{
			// question is ready to be rendered and there are no external widgets
			cc_Renderer.renderQuestion(question, isNew, sectionDivId);
		}
	};

	cc_Renderer.renderQuestion = function (question, isNew, sectionDivId) {
		// render top level question

		var html = cc_View.createQuestionHtml(question);
		if(isNew == true){
			$('#' + sectionDivId).append(html);
		}else{
			$('#' + sectionDivId).find("div[cc-panel=" + question.id + "]").replaceWith(html);
		}

		cc_Renderer.applyExternalWidgetOnRenderingCompleteFunction(question);
		cc_Renderer.applyRichQuestionAnswerStyles(question);
		cc_Renderer.attachValidator(question);

		// update on first render
		cc_Renderer.updateEnteredValue(question, question.entered);
		cc_Renderer.updateDisabledValue(question, true);

		// after the entered values are attached then attach the decorator
		cc_Renderer.attachDecorator(question);

		cc_Renderer.attachLayout(question);
		cc_Renderer.attachHelp(question);

		cc_Renderer.bindSubQuestions(question, null);
	}

	cc_Renderer.dettachQuestions = function (includeAllFields) {
		var detachedQuestions = [];

		$.each(cc_Model.topLevelQuestionMap, function (i) {
			var isOnSelectedPage = cc_Model.isOnSelectedPage(this);

			// dettach when:
			//	1) is operator or applicant and is on selected page (stateful session) OR
			//	2) is author (stateless session)
			if((cc_Config.userType != "author" && isOnSelectedPage === true) || cc_Config.userType === "author"){
				if (isOnSelectedPage === true) {
					cc_Renderer.dettachQuestion(this);
				}

				detachedQuestions.push(cc_Model.toAnsweredQuestion(this, includeAllFields));
			}
		});

		return detachedQuestions;
	};

	cc_Renderer.dettachQuestion = function (question) {
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.dettachQuestion(this);
			});
		}

		var isVisible = cc_View.findQuestionPanelById(question.id, ":visible").length > 0;

		// if question is included and on the current page then it has been viewed
		if(isVisible === true){
			question.viewed = true;
		}

		cc_Model.updateQuestionInclusionRenderedState(question, isVisible);

		// PLEASE NOTE:
		// when detaching a question get the entered state from the model and not the UI except for questions
		// that are in the process of being updated from the UI to the model.
		// this is because the UI and the model can be out of sync when processing an interview response
		// see. cc_Controller.handleResponse() where model is updated first then UI is generated of the UI

		var isNonVueJSExternalWidget = question.type.value === "external-widget" && cc_ExternalWidgetPlugin.VueJS2._isVueJSExternalWidget(question) === false;

		if(cc_Renderer.hasFieldChangeAwaitingModelWrite(question.id) || isNonVueJSExternalWidget === true){
			cc_Model.updateQuestionEnteredRenderedState(question, cc_Renderer.getQuestionEnteredValue(question));
		}

		return question;
	};

	cc_Renderer.addNewPage = function (page) {
		var pageHtml = cc_View.createPage(page);
		var pageNavigatorItemHtml = cc_View.createPageNavigatorItem(page);
		var pageBefore = cc_Model.getPageBefore(page.id, page.restricted);

		var pageNavigator = page.restricted === true ? "[id=cloudcase-page-navigator-restricted]" : "[id=cloudcase-page-navigator-unrestricted]";

		if(pageBefore){
			// insert new page in correct order
			$('#page-content #' + cc_View.getPageDivId(pageBefore.id)).after(pageHtml);
			$(pageNavigator + ' #' + cc_View.getPageNavigatorItemId(pageBefore.id)).after(pageNavigatorItemHtml);
		}else{
			// insert at the end
			$('#page-content').append(pageHtml);
			$(pageNavigator + '').append(pageNavigatorItemHtml);
		}

		// remove all previous click listeners and add new ones including the new page. also apply a throttle routine across them
		$('.page_navigator_item').off().on('click', $.throttle(1500, function () {
			// Incase mobile nav is up
			cc_Controller.save("PAGE_SELECTION", $(this).closest('li').attr("cc-page-id"));
			cip_Custom.hideNavigationOverlay();
		}));
	};

	cc_Renderer.addNewSection = function (question, section) {
		var newSectionIndex = cc_Model.getQuestionSectionIndex(question);

		var jSections = $('#' + cc_View.getPageDivId(question.page.id) + ' .panel-body .sections-container');
		var html = cc_View.createSection(question.page.id, section);

		if(newSectionIndex == 0){
			// always insert new section as first section.
			// note: this is an prepend operation as a question with no section could be added even when there are existing sections
			jSections.prepend(html);

		}else{
			// insert after existing section (note: eq() is offset by 1 ie starts at index 1)
			var jSectionsInsertionPoint = jSections.find('> .sectionHeader:eq(' + (newSectionIndex - 1) + ')');

			if(jSectionsInsertionPoint.length == 0){
				// this situation can occur when multiple new sections are being added for the first time. so
				// add the new section as the last section (using append())
				// i.e. they have been append in this render iteration but are not bound to the rendered dom yet so
				// the jquery selector does not return them
				jSections.append(html);
			}else{
				jSectionsInsertionPoint.after(html);
			}
		}
	};

	cc_Renderer.applyRichQuestionAnswerStyles = function (question){
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.applyRichQuestionAnswerStyles(this);
			});
		}

		if(question.type.styleName == 'auto-complete'){
			var source = null;
			var select = null;

			var jPanel = $(cc_View.findQuestionPanelById(question.id));
			var jField = $(cc_View.findQuestionFieldById(question.id));

			// add a hook for css
			jPanel.find('> .questionContainer > .questionContent').attr('cc-rich-style', 'auto-complete');

			if(question.type.value === 'search'){
				jPanel.find('.searchNoMatchLink').click(function (){
					cc_Renderer.updatedSearchEnteredValue(question.id, 'NO_MATCH_SELECTED', null);
					cc_Renderer.handleFieldChange(jField);
				});

				jPanel.find('.editSearchButton, .searchAgainLink').click(function (){
					cc_Renderer.updatedSearchEnteredValue(question.id, null, null);
					cc_Renderer.handleFieldChange(jField);
				});

				select = function(event, ui){
					// clone selected result so we can removed the 'value' property which is added by jquery ui autocomplete
					var selectedResult = cc_Util.clone(ui.item);
					delete selectedResult.value;

					cc_Renderer.updatedSearchEnteredValue(question.id, 'MATCH_SELECTED', selectedResult);
					cc_Renderer.handleFieldChange(jField);
				};

				source = function(sourceRequest, sourceResponse){
					cc_EntityIntegration.getSearchDataSourceResults(question.type.dataSourceReference, sourceRequest.term, sourceResponse);
				};

			}else{
				select = function(event, ui){
					// set the value on the field because handleFieldChange() needs to know the updated value.
					// however, the autocomplete question has not updated the field on executing the selection event
					jField.setValue(ui.item.value);

					// clone selected result so we can removed the 'value' property which is added by jquery ui autocomplete
					var selectedResult = cc_Util.clone(ui.item);
					delete selectedResult.value;

					cc_Renderer.handleFieldChange(jField);
				};

				// use the supplied option values
				source = question.values;
			}

			cc_UI.autocomplete(cc_View.findQuestionFieldById(question.id), source, select, 500, question.type.autoCompleteStyle.minimumLength, false);

			// add class so we have a hook to change the style of the form (without impacting areas )
			cc_View.findQuestionFieldById(question.id).autocomplete("widget").addClass("cloudcase-form-autocomplete");
		}
	};

	cc_Renderer.attachHelp = function (question){
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.attachHelp(this);
			});
		}

		if (question.type.value !== 'type-less') {
			var questionPanel = $('[cc-panel=' + question.id + ']');

			questionPanel.find('.questionContainer > .questionAnnotationsAndText > div > .questionHelpButton').first().on('click', function(){
				questionPanel.find('.questionContainer > .questionHelpContainer, > .questionHelpContainer').first().toggle();
			});
		}
	};

	cc_Renderer.attachLayout = function (question){
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.attachLayout(this);
			});
		}

		if(question.type.value === "type-less"){
			var layout = cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT, question);

			if(layout != null && layout == 'Horizontal'){
				var questionPanel = $('[cc-panel=' + question.id + ']');

				if(cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT_TEXT_POSITION, question) === 'Fixed'){
					questionPanel.find('> .questionContainer.fullWidthQuestion').removeClass('fullWidthQuestion').addClass('fixedWidthQuestion');
				}

				var row = null;
				if (question.hasSubQuestions) {

					var hasMustAnswerSubQuestion = false;

					$.each(question.subQuestions, function (i) {
						var subQuestion = this;
						var isNewRow = i === 0 || cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT_NEW_ROW, this) === 'true';
						var columns = cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT_COLUMNS, this);

						if(hasMustAnswerSubQuestion === false){
							hasMustAnswerSubQuestion = subQuestion.mustAnswer;
						}

						if(isNewRow === true){
							questionPanel.append('<div class="row layoutHorizontalRow"></div>');
							row = questionPanel.find('> .row:last');
						}

						var subQuestionPanel = $('[cc-panel=' + this.id + ']');
						var basis = (columns ? columns : '4') + '/12';
						if (columns === '12') {
							basis = 'full'
						}
						subQuestionPanel.addClass('basis-' + basis);

						if(subQuestion.type.value == 'boolean' || subQuestion.type.styleName == 'radio'){
							subQuestionPanel.find('> .questionContainer').removeClass('fixedWidthQuestion').addClass('floatingWidthQuestion');
						}

						row.append(subQuestionPanel.detach());
					});

					if(hasMustAnswerSubQuestion === true){
						questionPanel.find('> .questionContainer > .questionAnnotationsAndText > .questionAnnotations').html(
							cc_View.createQuestionHeadingMustAnswerHtml(true)
						);
					}

					if(cc_Model.getProperty(cc_Renderer.PROPERTY_HELP_TEXT, question) != null){
						questionPanel.find('> .layoutHorizontalRow:first').append(questionPanel.find('> .questionContainer > .questionHelpButton'));
						questionPanel.append(questionPanel.find('> .questionContainer > .questionHelpContainer'));
					}
				}
			}
		}
	};

	cc_Renderer.attachDecorator = function (question){
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.attachDecorator(this);
			});
		}

		if(question.type.value === "number"){
			var jFieldRaw = cc_View.findQuestionFieldById(question.id);
			var jFieldDecorator = cc_View.findQuestionFieldDecoratorByField(jFieldRaw);

			if(cc_UI.isMobileDevice() === true){
				// input[type=number] is used for mobile devices so the number part of the keypad is
				// brought up instead of the aplha. however the native number input on webkit will clear
				// the whole entered value if it contains inputs other than '-, ., 0-9'. as such the below logic
				// restricts input to those keys
				jFieldRaw.keypress(function(e) {
					if (e.which != 45 && e.which != 46 && !(e.which >= 48 && e.which <= 57)) {
						return false;
					}
				});
			}

			jFieldRaw.on("blur", function () {
				cc_Renderer.handleQuestionFieldExit(question, jFieldRaw, jFieldDecorator);
			});

			jFieldDecorator.on("focus", function (e) {
				cc_Renderer.handleQuestionFieldEnter(question, jFieldRaw, jFieldDecorator);
			});

			// after attaching the decorator execute a simulated blur to populated the decorated value
			cc_Renderer.handleQuestionFieldExit(question, jFieldRaw, jFieldDecorator);
		}
	};

	cc_Renderer.handleQuestionFieldEnter = function (question, jFieldRaw, jFieldDecorator){
		// on focus of the decorator only show the field
		jFieldDecorator.hide();
		// focus before showing so that the text selection is seemless when handing over from the decorator
		jFieldRaw.focus().show().focus();
	};

	cc_Renderer.handleQuestionFieldExit = function (question, jFieldRaw, jFieldDecorator){
		var raw = jFieldRaw.getValue();
		var entered = null;

		if(raw && raw != ''){
			var decorator = cc_Model.getProperty(cc_Renderer.PROPERTY_DECORATOR, question);

			var formatterOptions = {};
			if(decorator != null && numeral.kind(decorator) == 'percentage'){
				formatterOptions.scalePercentBy100 = cc_Renderer.shouldScalePercentageDecoratedQuestionBy100(question);
			}

			var parsed = numeral(raw, formatterOptions);
			entered = parsed.input(); // entered as typed

			// can input be parsed as a number (ie a value)
			var isParsedAsNumber = parsed.value() != null;

			if(isParsedAsNumber){
				// convert value back and forth. this will create the unformatted input value.
				//	for example: 1k becomes 1000, 1 000 becomes 1000, $1000 becomes 1000, 1,000 becomes 1000, 1000 becomes 1000
				entered = numeral(parsed.value()).value();
			}

			if(isParsedAsNumber && entered != null && decorator){
				// when there is an entered number decorate it
				jFieldDecorator.setValue(parsed.format(decorator, null, formatterOptions));

			}else{
				// otherwise update the decorator. this includes:
				// 	1. entered numbers without a decorator
				//	2. invalid inputs
				jFieldDecorator.setValue(entered);
			}

		}else{
			// user has cleared the field value so clear the decorator
			jFieldDecorator.setValue(entered);
		}

		// this does two things:
		// 	1. 	if the value as typed is different to the converted value then update the field.
		// 		the rule here is that the field must always have an unformatted number
		//	2. 	ensures that the text in the field is unselected (i.e. setting value clears the text selection)
		jFieldRaw.setValue(entered);

		// update entered value to trigger dependent logic including updating the model
		cc_Renderer.getQuestionEnteredValue(question, entered);

		// on blur of the field only show the decorator
		jFieldRaw.hide();
		jFieldDecorator.show();
	};

	cc_Renderer.shouldScalePercentageDecoratedQuestionBy100 = function (question){
		var scalePercentBy100 = false;

		if(cc_Util.isVersionLessThan(cc_Config.serverVersionOnRulebookSave, "11.1.0")){
			// backward compatible behaviour.
			// when decorated numbers are inputted using a '%' format they were always scaled by 100. this can create an unexpected outcome for a user. for example inputting '22' resulted as 2200%.
			scalePercentBy100 = true;

		}else if(cc_Util.isVersionLessThan(cc_Config.serverVersionOnRulebookSave, "11.2.0")){
			// backward compatible behaviour.
			// percentage inputs are not scaled by default. instead only numbers which have a '%' decorator and an allowed value of between 0 and 1 will be scaled by 100.
			scalePercentBy100 = (question.values[1].value - question.values[0].value) == 1;

		}else{
			// only scale percentages when the rulebook specifies scaling is required (i.e. leave it up to the author)
			var useDecimalPercentage = cc_Model.getProperty(cc_Renderer.PROPERTY_DECORATOR_USE_DECIMAL_PERCENTAGE, question);
			scalePercentBy100 = (useDecimalPercentage != null && useDecimalPercentage === 'true');
		}

		return scalePercentBy100;
	};

	cc_Renderer.hasExternalWidgets = function (question) {
		var hasExternalWidgets = (question.type.externalWidget != null && question.type.externalWidget.getEnteredFunktion != null); // get entered is mandatory

		if(hasExternalWidgets === false && question.hasSubQuestions === true) {
			for(var i = 0; i < question.subQuestions.length; i++){
				hasExternalWidgets = cc_Renderer.hasExternalWidgets(question.subQuestions[i]);

				if(hasExternalWidgets === true){
					break;
				}
			};
		}

		return hasExternalWidgets;
	};

	cc_Renderer.applyExternalWidgetAddToHeadFunction = function (question, externalWidgetsAddedToHead) {
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.applyExternalWidgetAddToHeadFunction(this, externalWidgetsAddedToHead);
			});
		}

		// only add to head once per external widget definition
		if(question.type.externalWidget && question.type.externalWidget.addToHeadFunktion != null && $.inArray(question.id, externalWidgetsAddedToHead) == -1){
			var html = eval(question.type.externalWidget.addToHeadFunktion + ';' + question.type.externalWidget.addToHeadFunktionName + '();');

			if(html){
				$('head').append(html);
				externalWidgetsAddedToHead.push(question.id);
			}
		}
	};

	cc_Renderer.renderQuestionAfterExternalWidgetsAreReadyToRender = function (question, doRenderQuestion) {
		var outstandingIsReadyToRenderTimers = [];

		// logic to ensure all questions are rendered
		var renderQuestionWhenReadyToRender = function(){

			// there is an outstanding question to be rendered (note: this include the question plus its sub questions)
			if(outstandingIsReadyToRenderTimers.length > 0){
				// external widget is not ready to be rendered, so wait then try again.
				// please note: a timeout is required so that the <script... tag which could have been added in the add-to-head is not blocked downloading
				setTimeout(renderQuestionWhenReadyToRender, 200);

			}else{
				// question is ready to be rendered
				doRenderQuestion();
			}
		};

		// run the is-ready-to-render, this will add to the outstandingIsReadyToRenderTimers
		cc_Renderer.applyExternalWidgetIsReadyToRenderFunction(question, outstandingIsReadyToRenderTimers);

		// start checking if question is ready to render (this includes all of its sub questions)
		renderQuestionWhenReadyToRender();
	}

	cc_Renderer.applyExternalWidgetIsReadyToRenderFunction = function (question, outstandingIsReadyToRenderTimers) {
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.applyExternalWidgetIsReadyToRenderFunction(this, outstandingIsReadyToRenderTimers);
			});
		}

		if(question.type.externalWidget && question.type.externalWidget.isReadyToRenderFunktion != null){
			var isReadyToRenderChecker = function() {
				var isReadyToRender = false;

				try{
					isReadyToRender = eval(question.type.externalWidget.isReadyToRenderFunktion + ';' + question.type.externalWidget.isReadyToRenderFunktionName + '();');
				}catch(e){
					isReadyToRender = false;
				}

				if (isReadyToRender === true) {
					cc_Util.removeElement(outstandingIsReadyToRenderTimers, question.id); // question is ready to render so remove it as outstanding

				}else{
					if(outstandingIsReadyToRenderTimers.indexOf(question.id) == -1){ // new checker so add it to the list
						outstandingIsReadyToRenderTimers.push(question.id); // only add once
					}

					// retry so we know that we are in a position to render
					setTimeout(isReadyToRenderChecker, 200);
				}
			}

			isReadyToRenderChecker(); // start checking if the specific external widget question is ready to render
		}
	};

	cc_Renderer.applyExternalWidgetOnRenderingCompleteFunction = function (question) {
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.applyExternalWidgetOnRenderingCompleteFunction(this);
			});
		}

		if(question.type.externalWidget && question.type.externalWidget.onRenderingCompleteFunktion){
			eval(question.type.externalWidget.onRenderingCompleteFunktion + ';' + question.type.externalWidget.onRenderingCompleteFunktionName + '();');
		}

		// CUSTOMISED SECTION --- VueJS Widget
		if (cc_ExternalWidgetPlugin.VueJS2 && cc_ExternalWidgetPlugin.VueJS2._isVueJSExternalWidget(question)) {
			cc_ExternalWidgetPlugin.VueJS2._updateTextValue(question.id, question.text);
		}
		// END CUSTOMISED SECTION --- VueJS Widget
	};

	cc_Renderer.applyExternalWidgetGetEnteredFunction = function (question) {
		var entered = null;

		if(question.type.externalWidget && question.type.externalWidget.getEnteredFunktion){
			entered = eval(question.type.externalWidget.getEnteredFunktion + ';' + question.type.externalWidget.getEnteredFunktionName + '();');
		}

		if(entered === null){
			entered = [];

		}else{
			for (var i = 0; i < entered.length; i++){
				if (!entered[i]){
					// convert null to a string representation, because the rules engine cant accept null values in the entered array
					entered[i] = 'null';
				}
			}
		}

		return entered;
	};

	cc_Renderer.attachValidator = function (question) {
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.attachValidator(this);
			});
		}

		if (question.hasValidator) {
			// debounce is to stop the error being shown when a question is selected then the user presses the next button
			cc_View.findQuestionFieldById(question.id).bind("blur", $.debounce(1000, function () {
				var question = cc_Model.anyLevelQuestionMap[$(this).attr('cc-field')];

				// server side errors controlled by ???
				if(question && cc_Renderer.hasServerSideError(question.id) === false){
					cc_Renderer.detachError(question.id);

					var entered = cc_Renderer.getQuestionEnteredValue(question);

					// validator is only supported for questions with a single entered value
					if (entered && entered.length == 1 && entered[0].length > 0) {
						// in the entered value replace double quote with single quote
						var validationCommand = question.validator.funktion + ';' + question.validator.funktionName + '("' + entered[0].replace(/"/g, "'") + '");';

						var validationError = eval(validationCommand);

						if (validationError) {
							cc_Model.allErrorsMap[question.id] = {
								id : question.id,
								message : validationError
							};

							cc_Renderer.attachError(question.id, validationError, "client");
						}
					}
				}
			}));
		}
	};

	cc_Renderer.hasServerSideError = function (questionId) {
		return cc_View.findErrorPanelById(questionId).find('[data-raised-by=server]').length != 0;
	};

	cc_Renderer.registerQuestionPanelUpdate = function (question, questionPanel) {
		var existingClasses = questionPanel.attr('class') ? questionPanel.attr('class').split(' ') : [];
		var newWatchedClasses = cc_View.createQuestionPanelComponentVisibilityClasses(question);

		existingClasses.forEach(existingClass => {
			var isWatched = existingClass.startsWith('shown') || existingClass.startsWith('hidden') || existingClass.startsWith('disabled');
			if(isWatched && newWatchedClasses.indexOf(existingClass) == -1){
				questionPanel.removeClass(existingClass);
			}
		});

		newWatchedClasses.forEach(newWatchedClass => {
			if(existingClasses.indexOf(newWatchedClass) == -1){
				questionPanel.addClass(newWatchedClass);
			}
		});
	};

	cc_Renderer.updateTextValue = function (question) {
		var questionPanel = cc_View.findQuestionPanelById(question.id);

		// support for VueJS2 widget - start
		if (cc_ExternalWidgetPlugin.VueJS2 && cc_ExternalWidgetPlugin.VueJS2._isVueJSExternalWidget(question)) {
			cc_ExternalWidgetPlugin.VueJS2._updateTextValue(question.id, question.text);
		}
		// support for VueJS2 widget - end

		// add document question returns a null text value when adding/removing a document
		var isAddDocumentQuestion = question.type.value == "add-document";

		if(questionPanel.length != 0 && isAddDocumentQuestion == false){
			var textPanel = cc_View.findQuestionTextById(question.id);
			var textSpan = textPanel.find('span').empty();

			if(question.text){
				textSpan.html(cc_View.createQuestionText(question));
			}

			// this logic is required for typeless questions without a text value which
			// are have been attached but are not viewable. when setting a text value on them,
			// questions of this type need to be shown
			cc_Renderer.registerQuestionPanelUpdate(question, questionPanel);
		}
	};

	cc_Renderer.updateResultValue = function (question) {
		var questionPanel = cc_View.findQuestionPanelById(question.id);

		if(questionPanel.length != 0){
			var resultPanel = cc_View.findResultPanelById(question.id).empty();

			if(question.result){
				resultPanel.append(cc_View.createResultMessage(question.result));
			}

			cc_Renderer.registerQuestionPanelUpdate(question, questionPanel);
		}
	};

	cc_Renderer.updateValuesValue = function (question) {
		if(question.values){
			if (question.type.hasAnInputType) {

				switch (question.type.value) {
					case 'single-select':
						// remove existing values and recreate
						if(question.type.styleName == 'radio'){
							$('[cc-group-question-id="' + question.id + '"]').empty().append(cc_View.createSingleSelectRadioOptionsHtml(question));

						}else if(question.type.styleName == 'list'){
							$('select[cc-field="' + question.id + '"]').empty().append(cc_View.createSingleSelectListOptionsHtml(question));

						}else if(question.type.styleName == 'auto-complete'){
							$('input[cc-field="' + question.id + '"]').setValue('');
							$('input[cc-field="' + question.id + '"]').autocomplete('option', 'source', question.values);
						}

						break;
					case 'multi-select':
						// remove existing values and recreate
						$('[cc-group-question-id="' + question.id + '"]').empty().append(cc_View.createMultiSelectOptionsHtml(question));
						break;
				}

				var previousQuestionState = cc_Model.getQuestionRenderedState(question);

				if(previousQuestionState){
					if(previousQuestionState.entered){
						// ensure the original entered state is applied (if option still exists)
						cc_Renderer.updateEnteredValue(question, previousQuestionState.entered);
					}

					// reapply correct disabled state
					cc_Renderer.updateDisabledValue(question, false);
				}
			}
		}
	};

	cc_Renderer.updateDisabledValue = function (question, updateSubQuestions) {
		var questionPanel = cc_View.findQuestionPanelById(question.id);
		var isDisabled = question.disabled === true || question.page.readOnly === true;

		if(question.type.value === 'search'){
			var isFieldDisabled = true;

			// an input restricted question has had its input stopped. even though the input is disabled this does not mean
			// the question is disabled from a CC.getQuestion().setDisabled() perspective. therefore if the question is input restricted
			// don't enable when CC.getQuestion().isDisabled() == false
			if(isDisabled === false){
				// only enable the search field when it is blank (ie no selected value and the not match link has not been pressed)
				if(question.entered[0] == null){
					isFieldDisabled = false;
				}
			}
		}else{
			isFieldDisabled = isDisabled;
		}

		// support for VueJS2 widget - start
		if (cc_ExternalWidgetPlugin.VueJS2 && cc_ExternalWidgetPlugin.VueJS2._isVueJSExternalWidget(question)) {
			cc_ExternalWidgetPlugin.VueJS2._updateDisabledValue(question.id, isFieldDisabled);
		}
		// support for VueJS2 widget - end

		// we need to update all fields not just the enterable ones, for instance add-document upload button or button groups.
		// all disableable inputs of this type have the cc-disableable attribute
		var disableableQuestion = cc_View.findQuestionDisabledById(question.id);

		// prop is used for inputs and attr is used for labels (i.e. button group options)
		disableableQuestion.prop('disabled', isFieldDisabled).attr('disabled', isFieldDisabled);
		disableableQuestion.parent().find('.dropdown-toggle').prop('disabled', isFieldDisabled);

		// For checkboxes and radios, we need to add in a class whether it is disabled or not so that CSS can match easier
		if ($(disableableQuestion).closest(".questionContent .multiAnswerGroup").length > 0) {
			if (isDisabled) {
				$(disableableQuestion).closest(".questionContent .multiAnswerGroup").addClass("disabled");
			} else {
				$(disableableQuestion).closest(".questionContent .multiAnswerGroup").removeClass("disabled");
			}
		}

		// For Document Uploads, we need ot add in a class whether it is disabled or not so that CSS can match easier
		if ($(disableableQuestion).closest(".questionContent .missingDocumentPanel, .questionContent .addedDocumentPanel").length > 0) {
			if (isDisabled) {
				$(disableableQuestion).closest(".questionContent .missingDocumentPanel, .questionContent .addedDocumentPanel").addClass("disabled");
			} else {
				$(disableableQuestion).closest(".questionContent .missingDocumentPanel, .questionContent .addedDocumentPanel").removeClass("disabled");
			}
		}

		if (updateSubQuestions === true && question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.updateDisabledValue(this, true);
			});
		}
		// ensure question is correctly disabled
		cc_Renderer.registerQuestionPanelUpdate(question, questionPanel);
	};

	cc_Renderer.updateEnteredValue = function (question, entered, updateSubQuestions) {
		var questionPanel = cc_View.findQuestionPanelById(question.id);

		if (question.type.hasAnInputType) {
			var currentEnteredValue = cc_Renderer.getQuestionEnteredValue(question); // current value on the DOM
			var hasChangedEnteredValue = cc_Util.areArraysEqual(currentEnteredValue, entered) === false;

			// support for VueJS2 widget - start
			if (cc_ExternalWidgetPlugin.VueJS2 && cc_ExternalWidgetPlugin.VueJS2._isVueJSExternalWidget(question)) {
				cc_ExternalWidgetPlugin.VueJS2._updateEnteredValue(question.id, entered);
			}
			// support for VueJS2 Widget - end

			// only update the DOM when the updated entered value is different.
			// note: add document questions are rendered for the first time via updateFieldValue() not via the view.
			// so lets always update the field just to ensure its is rendered correctly
			if(hasChangedEnteredValue === true || question.type.value === "add-document" ||
				question.type.styleName === 'radio' || question.type.value === "multi-select" || question.type.value === "boolean") {
				cc_Renderer.updateFieldValue(question, entered);
			}

			cc_Model.updateQuestionEnteredRenderedState(question, entered);
		}

		if(typeof updateSubQuestions === "undefined" || updateSubQuestions === true){
			if (question.hasSubQuestions) {
				cc_Util.invokeOnElements(question.subQuestions, function () {
					cc_Renderer.updateEnteredValue(this, this.entered, true);
				});
			}
		}

		// ensure question is correctly shown
		cc_Renderer.registerQuestionPanelUpdate(question, questionPanel);
	};

	cc_Renderer.updateFieldValue = function (question, entered) {
		if(question.type.value === 'add-document'){
			var questionPanel = cc_View.findQuestionPanelById(question.id);
			questionPanel.find('.questionContent').empty().append(cc_View.createAddDocumentQuestionContentHtml(question));

			cc_Renderer.attachAddDocumentButtonListeners(questionPanel, question);

		}else{
			var jField = cc_View.findQuestionFieldById(question.id);

			if(entered && entered.length > 0){
				switch (question.type.value) {
					case 'free-text':
					case 'number':
					case 'range':
					case 'boolean':
					case 'single-select':
						if(jField.length > 1){
							var customStyle = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);

							// radio buttons and check box groups have multiple fields which need to be selected by the value of the correct field
							$.each(jField, function(){
								var hasValue = $.inArray(this.value, entered) != -1;

								$(this).setValue(hasValue ? this.value : null);
								if(hasValue){
									$(this).parent().addClass('active');
								} else {
									$(this).parent().removeClass('active');
								}
							});
						}else{
							// text boxes, drop downs etc which have a single value
							jField.setValue(entered[0]);

							if(question.type.value === 'number'){
								cc_Renderer.refreshDecoratedValue(question);
							}
						}
						break;
					case 'multi-select':
						if(jField.length > 1){
							var customStyle = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);

							// radio buttons and check box groups have multiple fields which need to be selected by the value of the correct field
							$.each(jField, function(){
								var hasValue = $.inArray(this.value, entered) != -1;

								$(this).setValue(hasValue ? this.value : null);
								if(hasValue){
									$(this).parent().parent().addClass('active');
								} else {
									$(this).parent().parent().removeClass('active');
								}
							});
						}else{
							// text boxes, drop downs etc which have a single value
							jField.setValue(entered[0]);

							if(question.type.value === 'number'){
								cc_Renderer.refreshDecoratedValue(question);
							}
						}
						break;
					case 'search':
						cc_Renderer.updatedSearchEnteredValue(question.id, entered[0], entered[1] ? entered[1] : null);
						break;

					case 'date':
						var date = entered[0].split('-');
						// parse segments as ints to remove leading zeros
						cc_View.findQuestionFieldById(question.id, ':eq(0)').setValue(parseInt(date[2]));
						cc_View.findQuestionFieldById(question.id, ':eq(1)').setValue(parseInt(date[1]));
						cc_View.findQuestionFieldById(question.id, ':eq(2)').setValue(parseInt(date[0]));
						break;
				}

			}else{
				jField.setValue(null);

				// clear active
				if(cc_Renderer.hasButtonGroupStyle(question)){
					cc_Renderer.clearActiveButtonGroup(question);
				}

				// clear decorated value
				if(question.type.value === 'number'){
					cc_Renderer.refreshDecoratedValue(question);
				}
			}
		}
	}

	cc_Renderer.clearActiveButtonGroup = function (question){
		var jField = cc_View.findQuestionFieldById(question.id);
		var jLabel = cc_View.findQuestionLabelByField(jField);
		$(jLabel).removeClass('active');
	}

	cc_Renderer.refreshDecoratedValue = function (question){
		var jFieldRaw = cc_View.findQuestionFieldById(question.id);
		var jFieldDecorator = cc_View.findQuestionFieldDecoratorByField(jFieldRaw);

		// after updating the raw value execute a simulated blur to populated the decorated value
		cc_Renderer.handleQuestionFieldExit(question, jFieldRaw, jFieldDecorator);
	};

	cc_Renderer.updatedSearchEnteredValue = function (questionId, selectionType, selectionResult) {
		var jPanel = $(cc_View.findQuestionPanelById(questionId));
		var jContainer = jPanel.find('.questionContainer');
		var jField = $(cc_View.findQuestionFieldById(questionId));
		var fieldValue = null;
		var restrictSearchAccess = null;

		if(selectionType === 'MATCH_SELECTED'){
			var selectionResultIsAString = (typeof selectionResult === 'string' || selectionResult instanceof String);
			var selectionResultAsString, selectionResultAsObject;

			if(selectionResultIsAString === true){
				selectionResultAsString = selectionResult;
				selectionResultAsObject	= JSON.parse(selectionResult);
			}else{
				selectionResultAsString = cc_Util.stringify(selectionResult);
				selectionResultAsObject	= selectionResult;
			}

			jContainer.attr('data-search-selection-type', 'MATCH_SELECTED');

			// the user has selected a value from the drop list so we set the type of MATCH_SELECTED and stringify the selected object.
			// these two items become the first and second elements in the entered value
			jField.attr('data-search-selection-type', 'MATCH_SELECTED').attr('data-search-selection-result', selectionResultAsString).blur();
			jPanel.find('.ui-autocomplete-input').show();
			fieldValue = selectionResultAsObject.label;
			restrictSearchAccess = true;

		}else if(selectionType === 'NO_MATCH_SELECTED'){
			jContainer.attr('data-search-selection-type', 'NO_MATCH_SELECTED');

			// set the entered type as NO_MATCH_SELECTED and clear the selected item result. this will lead to an enetred value length or 1.
			// note: blur is called to trigger the question field update listeners as the NO_MATCH_SELECTED is a valid entered value. so the
			// question is considered answered.
			jField.setValue('').attr('data-search-selection-type', 'NO_MATCH_SELECTED').attr('data-search-selection-result', '').blur();
			jPanel.find('.ui-autocomplete-input').hide();
			restrictSearchAccess = true;

		}else if(selectionType === null){
			jContainer.removeAttr('data-search-selection-type');

			// reset question back to its initial state
			jField.setValue('').attr('data-search-selection-type', '').attr('data-search-selection-result', '').focus();
			jPanel.find('.ui-autocomplete-input').show();
			restrictSearchAccess = false;
		}

		// parse the json string to get the label property which contains the string to be shown in the dropdown
		jField.setValue(fieldValue).prop('disabled', restrictSearchAccess);
		jField.parent().find('.dropdown-toggle').prop('disabled', restrictSearchAccess);
	};

	cc_Renderer.attachAddDocumentButtonListeners = function (jQuestionPanel, question) {
		var jMissingDocumentPanel = jQuestionPanel.find('.missingDocumentPanel');
		if(jMissingDocumentPanel.length > 0){
			var documentFile = jMissingDocumentPanel.find('.uploadDocumentFile');
			if (documentFile.length > 0) {
				documentFile.change(function(){
					if (jQuestionPanel.find(".uploadDocumentFile")[0].value != "") {
						cc_EntityIntegration.addDocumentToQuestion(cc_Config.applicationId, question.id, jQuestionPanel.find('form'));
					}
				});

				// Allow file drop directly onto the dropzone attach file
				jMissingDocumentPanel
					.on("dragover", false)
					.on("drop", function(event) {
						if (event.originalEvent && event.originalEvent.dataTransfer && event.originalEvent.dataTransfer.files) {
							event.preventDefault();
							event.stopPropagation();
							if (documentFile.length > 0) {
								jQuestionPanel.find(".uploadDocumentFile")[0].files = event.originalEvent.dataTransfer.files;
								documentFile.change();
							}
						}
					});
			}
		}

		var jAddDocumentPanel = jQuestionPanel.find('.addedDocumentPanel');
		if(jAddDocumentPanel.length > 0){
			jAddDocumentPanel.find('.removeDocumentButton').click(function(){
				cc_EntityIntegration.removeDocumentFromQuestion(cc_Config.applicationId, question.id, $(this).attr('data-documentid'));
			});
		}
	};

	cc_Renderer.bindSubQuestions = function (question, parent) {
		if (question.hasSubQuestions) {
			cc_Util.invokeOnElements(question.subQuestions, function () {
				cc_Renderer.bindSubQuestions(this, question);
			}, question);
		}

		if (question.hasParentQuestion && parent != null ) {
			if (question.onlyAskIfParentIsAnyAnswer == true || question.onlyAskIfParentHasAnswer == true) {
				var parentId = question.parentQuestionId;

				cc_View.findQuestionFieldById(parentId).bind("change", [parent, question] , function (event) {
					cc_Renderer.handleParentChangeEvent(event.data[0], event.data[1]);

				}).bind("keydown", function (event){
					var code = event.charCode || event.keyCode;

					if(code && code == 9) {
						// tab pressed so check if new sub questions are exposed
						// then refocus on the tabbed field and continue with tab
						$(this).change().focus();
					};
				});
			}
		}
	};

	cc_Renderer.handleParentChangeEvent = function (triggeringQuestion, listeningQuestion) {
		var parentEnteredValue = cc_Renderer.getQuestionEnteredValue(triggeringQuestion);

		var match = false;

		if(listeningQuestion.concealed == false){
			if (parentEnteredValue && parentEnteredValue.length > 0) {
				if (listeningQuestion.onlyAskIfParentIsAnyAnswer == true) {
					$.each(parentEnteredValue, function () {
						if (listeningQuestion.onlyAskIfParentIsAnyAnswerValues == null) {
							match = true;

						}else if ($.isArray(listeningQuestion.onlyAskIfParentIsAnyAnswerValues)) {
							if ($.inArray(this.toString(), listeningQuestion.onlyAskIfParentIsAnyAnswerValues) != -1) {
								match = true;
								return false;
							}
						}else if (this.toString() == listeningQuestion.onlyAskIfParentIsAnyAnswerValues) {
							match = true;
							return false;
						}

						return true;
					});
				}else if (listeningQuestion.onlyAskIfParentHasAnswer == true) {
					match = true;
				}
			}

			if (match) {
				cc_View.findQuestionPanelById(listeningQuestion.id).show();
			}else{
				cc_View.findQuestionPanelById(listeningQuestion.id).hide();
			}
		}

		// ensure inclusion state is kept up to date when question visibility is updated
		cc_Model.updateQuestionInclusionRenderedState(listeningQuestion, match);
	};

	cc_Renderer.attachFieldChangeListeners = function () {
		var jAllFieldsOnPage = $('#' + cc_Model.getSelectedPageId() + '.questions')
			.find('input[cc-field]:enabled, button[cc-field]:enabled, select[cc-field]:enabled, textarea[cc-field]:enabled')
			.not('.cc-listener-attached');

		if(jAllFieldsOnPage.length > 0){
			var callback = function(){
				var questionId = $(this).attr('cc-field');

				cc_Renderer.handleFieldChange(this);

				cc_Renderer.fieldChangeWrittenToModel(questionId);
			};

			var onEvent = function(debounceHandler){
				return function(){
					var questionId = $(this).attr('cc-field');

					cc_Renderer.registerFieldChangeAwaitingModelWrite(questionId);

					var selectedPage = $("#" + cc_View.getPageDivId(cc_Model.getSelectedPageId()));
					var isShowingInterviewDialog = cc_View.isShowingDialogId("interviewDialog");

					// store the scroll top position when the user triggered field change the event
					cc_Renderer.lastQuestionChangedScrollTop = isShowingInterviewDialog === true ? selectedPage.offset().top : document.documentElement.scrollTop;

					debounceHandler.call(this);
				}
			};

			// do not change these values as focusing can become messed up
			// -> for example on entering a value then press tab, if the question has a server trigger, is the correct question focused once the throbber goes away?
			jAllFieldsOnPage.filter('input[type=text], input[type=number], textarea') // note number is used on mobile devices
				.bind('blur', onEvent($.debounce(250, callback))); // allow enough time to focus on the next question if the user has tabbed

			// tablet text field editor disappears on debounce trigger
			if(cc_UI.isMobileDevice() === false){
				jAllFieldsOnPage.filter('input[type=text], textarea')
					.bind('keydown', onEvent($.debounce(2500, callback))); // allow enough time for user to think and add more characters
			}

			jAllFieldsOnPage.filter('select, input[type=radio], input[type=checkbox]')
				.bind('change', onEvent($.debounce(75, callback))); // allow enough time to focus on the next question if the user has tabbed

			jAllFieldsOnPage.addClass('cc-listener-attached'); // ensure listener is only attached once
		}
	};

	cc_Renderer.hasFieldChangeAwaitingModelWrite = function(questionId){
		return cc_Util.containsElement(cc_Renderer.fieldChangeAwaitingModelWrite, questionId);
	};

	cc_Renderer.registerFieldChangeAwaitingModelWrite = function(questionId){
		if(cc_Renderer.hasFieldChangeAwaitingModelWrite(questionId) === false){
			cc_Renderer.fieldChangeAwaitingModelWrite.push(questionId);
		}
	};

	cc_Renderer.fieldChangeWrittenToModel = function(questionId){
		if(cc_Renderer.hasFieldChangeAwaitingModelWrite(questionId) === true){
			cc_Util.removeElement(cc_Renderer.fieldChangeAwaitingModelWrite, questionId);
		}
	};

	cc_Renderer.handleFieldChange = function (field) {
		// if the field is not visible then it means the user has changed pages. therefore the
		// change was already sent to the server and processed so when can ignore this event
		if(cc_View.findQuestionPanelByField(field).is(':visible') === true){
			var question = cc_Model.anyLevelQuestionMap[$(field).attr('cc-field')];
			var questionState = cc_Model.anyLevelQuestionRenderedStateMap[question.id];

			var isQuestionTriggerToAskAnotherQuestion = cc_Model.isQuestionTriggerToAskAnotherQuestion(question.id);

			if(questionState){
				var previousEnteredValue = questionState.entered;
				var updatedEnteredValue = cc_Renderer.applyEnteredSubstitution(question, cc_Renderer.getQuestionEnteredValue(question));

				var hasChangedEnteredValue = cc_Util.areArraysEqual(previousEnteredValue, updatedEnteredValue) === false;

				if(hasChangedEnteredValue === true){
					cc_Renderer.updateEnteredValue(question, updatedEnteredValue, false); // don't update sub questions

					if(isQuestionTriggerToAskAnotherQuestion === true){
						cc_Controller.save("QUESTION_TRIGGER", null, question.id);

					}else{
						cc_Renderer.refreshPageWizard();
					}

					if(cc_EntityIntegration.onPostChangedEnteredValue){
						cc_EntityIntegration.onPostChangedEnteredValue(question, updatedEnteredValue);
					}
				}
			}
		}
	};

	cc_Renderer.applyEnteredSubstitution = function (question, updatedEnteredValue) {
		if(question != null && question.type.value === 'free-text' && updatedEnteredValue != null && updatedEnteredValue.length > 0){
			var regexMatch = cc_Model.getProperty(cc_Renderer.PROPERTY_ENTERED_REGEX_MATCH, question);
			var regexSubstitution = cc_Model.getProperty(cc_Renderer.PROPERTY_ENTERED_REGEX_SUBSTITUTION, question);

			if(regexMatch != null && regexSubstitution != null){
				try{
					var substitutionUpdatedEnteredValue = updatedEnteredValue[0].replace(new RegExp(regexMatch, 'gm'), regexSubstitution)

					if(updatedEnteredValue[0] !== substitutionUpdatedEnteredValue){
						cc_Renderer.updateFieldValue(question, [substitutionUpdatedEnteredValue]);
						updatedEnteredValue = cc_Renderer.getQuestionEnteredValue(question);
					}
				}catch(e){
					// if we can't suppress then lets skip and move on
				}
			}
		}

		return updatedEnteredValue;
	};

	// TODO cc_Renderer.getCurrentFocusedQuestion() and cc_UI.getFocusedQuestionId() should be merged
	cc_Renderer.getCurrentFocusedQuestion = function () {
		var focused = cc_Util.getFocused();

		return (focused && focused.length > 0) ? $(focused).attr('cc-field') : null;
	};

	cc_Renderer.snapshotQuestionFocus = function () {
		cc_Renderer.focusedQuestionId = cc_Renderer.getCurrentFocusedQuestion();

		//cc_Util.log("cc_Renderer.snapshotQuestionFocus()", cc_Renderer.focusedQuestionId);
	};

	cc_Renderer.reinstateQuestionFocus = function () {
		var focused = cc_Util.getFocused();

		// only reinstate to the snapshoted focused question when their is no current focused item.
		// it is better to keep the users currently selected focus than revert to the last snapshoted question.
		// the reinstatement is used when the throbber has been shown and focus was lost
		if(focused && focused.length == 0){
			cc_Util.log("cc_Renderer.reinstateQuestionFocus()", cc_Renderer.focusedQuestionId);

			if(cc_Renderer.focusedQuestionId && cc_Renderer.focusedQuestionId.length > 0){
				cc_View.findQuestionFieldById(cc_Renderer.focusedQuestionId).focus();
				cc_Renderer.focusedQuestionId = null;
			}
		}
	};

	cc_Renderer.refreshPageWizard = function(){
		var save = cc_EntityIntegration.createSaveButtonText(cc_Model.isFirstPageSelected, cc_Model.isLastNonRestrictedPageSelected, cc_Model.isWritableRestrictedPageSelected,
					cc_Model.isReadyToFinish, cc_Model.isInterviewComplete, cc_Model.treatInterviewAsCompletedOnLoad);

		var next = cc_EntityIntegration.createNextButtonText(cc_Model.isFirstPageSelected, cc_Model.isLastNonRestrictedPageSelected, cc_Model.isWritableRestrictedPageSelected,
					cc_Model.isReadyToFinish, cc_Model.isInterviewComplete, cc_Model.treatInterviewAsCompletedOnLoad);

		var previous = cc_EntityIntegration.createPreviousButtonText(cc_Model.isFirstPageSelected, cc_Model.isLastNonRestrictedPageSelected, cc_Model.isWritableRestrictedPageSelected,
					cc_Model.isReadyToFinish, cc_Model.isInterviewComplete, cc_Model.treatInterviewAsCompletedOnLoad);

		if(cc_Model.isRestrictedPageSelected === true){
			// previous and next are not supported for restericted pages
			previous = null;
			next = null;

			if(cc_Model.isWritableRestrictedPageSelected === false){
				// save button is only allowed for writable restrcited pages
				save = null;
			}
		}

		var buttonPanel = cc_View.createButtonPanel(cc_Model.isInterviewComplete, next, previous, save);

		$(".panel-collapse .panel-body").find(".buttonPanel").unbind().remove();
		var sectionContainer = $(".panel-collapse .panel-body .sections-container");

		if(cc_Config.interviewButtonOptions.showOnTop === true){
			sectionContainer.before(buttonPanel);
		}

		sectionContainer.after(buttonPanel);

		$(".panel-heading").unbind().click($.throttle(1500, function () {
			var tagName = $(this).tag();
			var a = null;

			if(tagName === "div"){
				a = $(this).find("a");
			}else if(tagName === "a"){
				a = $(this);
			}

			if(a){
				var pageId = a.attr("href").split("#")[1];
				cc_Controller.save("PAGE_SELECTION", pageId);
			}
		}));

		$(".buttonPanel").find("button.next").click($.throttle(2500, function(e) {
			e.preventDefault();
			cc_Controller.save("NEXT");
		}));
		$(".buttonPanel").find("button.previous").click($.throttle(2500, function(e) {
			e.preventDefault();
			cc_Controller.save("PREVIOUS");
		}));
		$(".buttonPanel").find("button.save").click($.throttle(2500, function(e) {
			e.preventDefault();
			cc_Controller.save("SAVE");
		}));

        if ($(".navbar-header").hasClass("has-attached-listeners") != true) {
            $(".navbar-header").children("button.save").click($.throttle(2500, function (e) {
                e.preventDefault();
                cc_Controller.save("SAVE");
            }));
            $(".navbar-header").addClass("has-attached-listeners");
        }

		$('.collapse').unbind().on('show.bs.collapse', function(){
			$(this).parent().find(".panel-heading").addClass("selected");

		}).on('hide.bs.collapse', function(){
			$(this).parent().find(".panel-heading").removeClass("selected");
		});
	};

	cc_Renderer.scrollToCaptureUserAttention = function (result) {
		if(cc_Renderer.enableScrollToCaptureUserAttention === true){

			// don't scroll when new questions are added to current page
			var hasNewlyShownQuestionsOnSelectedPage = result.newlyShownQuestionsOnSelectedPage && result.newlyShownQuestionsOnSelectedPage.length > 0;

			var isScrollableTriggerType = hasNewlyShownQuestionsOnSelectedPage == false && (result.triggerType == "NEXT" || result.triggerType == "PREVIOUS" || result.triggerType == "PAGE_SELECTION");

			var firstQuestionInError = $('.questions:visible .errorText:first').closest('.shownQuestionPanel');

			// only scroll to error when there is an error and either save or next was pressed
			var hasChangedPage = cc_Model.selectedPageIdBeforeHandleResponse != cc_Model.getSelectedPageId();
			var scrollToFirstQuestionError = firstQuestionInError.length > 0 && hasChangedPage === false && (result.triggerType === "NEXT" || result.triggerType === "SAVE");

			if((isScrollableTriggerType === true || scrollToFirstQuestionError === true) && result.isFirstRequest === false){
				var doCaptureUserAttention = function(isAnimated){
					var isShowingInterviewDialog = cc_View.isShowingDialogId("interviewDialog");
					var elementToScrollTo;

					if(scrollToFirstQuestionError === true){
						elementToScrollTo = firstQuestionInError;
					}else if(isShowingInterviewDialog === true){
						elementToScrollTo = $('#interviewDialog');
					}else{
						elementToScrollTo = $(window);
					}

					if(cc_UI.hasVisibleDialog() === false || isShowingInterviewDialog === true){
						var selectedPageId = cc_Model.getSelectedPageId();
						var selectedPage = $("#" + cc_View.getPageDivId(selectedPageId));

						if(isAnimated === true){
							if(isShowingInterviewDialog === true){
								$('#interviewDialog').animate({scrollTop: elementToScrollTo.offset().top - selectedPage.offset().top}, 600, 'linear');
							}else{
								$('html,body').animate({scrollTop: elementToScrollTo.offset().top}, 600, 'linear');
							}
						}else{
							$(elementToScrollTo[0]).scrollTop(0);
						}
					}
				};

				// always ensure the page is instantally at the top of the screen, dont animate it there
				if(scrollToFirstQuestionError === false){
					doCaptureUserAttention(false);
				}else{
					$.doTimeout(250, function(){
						doCaptureUserAttention(true);
					});
				}
			}
		}
	};

	cc_Renderer.isPageNavigatorVisible = function () {
		return $('#cloudcase-page-navigator').is(':visible');
	};

	cc_Renderer.attachNewErrors = function (invalidErrors) {
		cc_Util.invokeOnElements(invalidErrors, function () {
			cc_Renderer.attachError(this.id, this.message, "server");
		});
	};

	cc_Renderer.attachError = function (questionId, message, raisedBy) {
		var questionPanel = cc_View.findQuestionPanelById(questionId);

		if(questionPanel.length != 0){
			cc_View.findErrorPanelById(questionId).empty().append(cc_View.createErrorMessage(message, raisedBy));
		}

		var question = cc_Model.anyLevelQuestionMap[questionId];

		if(question){
			cc_Model.updateQuestionErrorRenderedState(question, message); // when attaching an error ensure the rendered state is up to date
			cc_Renderer.attachPageError(question.page.id);
		}

		cc_Renderer.registerQuestionPanelUpdate(question, questionPanel);
	};

	cc_Renderer.attachPageCompletionIcons = function (pageId) {
		if($('#' + cc_View.getPageDivId(pageId) + ' .panel-heading .completedIcon').length === 0) {
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').find('i').remove();
			var pageHierarchy = cip_Custom.determinePageHierarchy(cc_Model.topLevelPagesMap[pageId]);
			if (pageHierarchy.subpage) {
				$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').append(cc_View.createPageNavigatorCompletedIcon(pageId));
			} else {
				$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').append(cc_View.createAccentedCompletedIcon(pageId));
			}
		}

		if ($(cip_Custom.getPageNavigatorItemSelector(pageId) + ' .completedIcon').length === 0) {
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).addClass("completed");
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).find('i').remove();
			var pageHierarchy = cip_Custom.determinePageHierarchy(cc_Model.topLevelPagesMap[pageId]);
			if (pageHierarchy.subpage) {
				$(cip_Custom.getPageNavigatorItemSelector(pageId)).prepend(cc_View.createCompletedIcon(pageId));
			} else {
				$(cip_Custom.getPageNavigatorItemSelector(pageId)).prepend(cc_View.createAccentedCompletedIcon(pageId));
			}
		}
	};

	cc_Renderer.attachPageError = function (pageId) {
		if($('#' + cc_View.getPageDivId(pageId) + ' .panel-heading .errorIcon').length == 0) {
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').find('.activeEditIcon').remove();
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').find('.placeholderIcon').remove();
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').children('.completedIcon').remove();
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').append(cc_View.createPageNavigatorErrorIcon(pageId));
		}

		if ($(cip_Custom.getPageNavigatorItemSelector(pageId) + ' .errorIcon').length == 0) {
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).find('.activeEditIcon').remove();
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).find('.placeholderIcon').remove();
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).find('.completedIcon').remove();
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).prepend(cc_View.createPageNavigatorErrorIcon(pageId));
		}
	};

	cc_Renderer.attachPageWarning = function (pageId) {
		if($('#' + cc_View.getPageDivId(pageId) + ' .panel-heading .warningIcon').length == 0) {
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').children('.activeEditIcon').remove();
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').children('.placeholderIcon').remove();
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').children('.completedIcon').remove();
			$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading').append(cc_View.createPageNavigatorWarningIcon(pageId));
		}

		if ($(cip_Custom.getPageNavigatorItemSelector(pageId) + ' .warningIcon').length === 0) {
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).children('.activeEditIcon').remove();
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).children('.placeholderIcon').remove();
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).children('.completedIcon').remove();
			$(cip_Custom.getPageNavigatorItemSelector(pageId)).prepend(cc_View.createPageNavigatorWarningIcon(pageId));
		}
	};

	cc_Renderer.detachPageWarning = function (pageId) {
		$('#' + cc_View.getPageDivId(pageId) + ' .panel-heading .warningIcon').remove();
		cc_Renderer.attachActiveEditIcon(pageId);
		$(cip_Custom.getPageNavigatorItemSelector(pageId) + ' .warningIcon').remove();
	};

	cc_Renderer.detachError = function (questionId) {
		var question = cc_Model.anyLevelQuestionMap[questionId];

		if (question) {
			var questionPanel = cc_View.findQuestionPanelById(question.id);

			cc_Model.updateQuestionErrorRenderedState(question, null); // when detaching an error ensure the rendered state is up to date
			cc_View.findErrorPanelById(question.id).empty();

			// if there are no question errors on the page then remove the page level errors
			if($('#' + cc_View.getPageDivId(question.page.id) + ' .errorText:visible').length === 0){
				$('#' + cc_View.getPageDivId(question.page.id) + ' .errorIcon').remove();
				$('#' + cc_View.getPageNavigatorItemId(question.page.id) + ' .errorIcon').remove();
				if ($('#' + cc_View.getPageNavigatorItemId(question.page.id) + ' i').length == 0) { // If there are any other icons present, don't show the placeholder
					$('#' + cc_View.getPageNavigatorItemId(question.page.id)).prepend(cc_View.createPageNavigatorPlaceholderIcon());
				}
			}

			cc_Renderer.registerQuestionPanelUpdate(question, questionPanel);
		}
	};

	cc_Renderer.detachPageCompletionIcons = function (pageId) {
		$('.completedIcon').remove();
		cc_Renderer.attachActiveEditIcon(pageId);
		if ($('#' + cc_View.getPageNavigatorItemId(pageId) + ' i').length == 0) { // If there are any other icons present, don't show the placeholder
			$('#' + cc_View.getPageNavigatorItemId(pageId)).prepend(cc_View.createPageNavigatorPlaceholderIcon());
		}
	};

	cc_Renderer.getQuestionEnteredValue = function (question) {
		var entered = null;
		var jField = cc_View.findQuestionFieldById(question.id);

		if (question.type.hasAnInputType) {
			if(question.type.value == 'search'){
				var selectionType = jField.attr("data-search-selection-type")
				var selectionResult = jField.attr("data-search-selection-result");

				entered = [];
				if (selectionType && selectionType != '') {
					entered.push(selectionType);
				}
				if (selectionResult && selectionResult != '') {
					entered.push(selectionResult);
				}

			}else if (question.type.value == 'date') {
				var rawValue = jField.fieldArray();

				// if date segments have not been selected (Y/M/D) then the entered value is blank
				entered = [];
				if(rawValue.length > 0 && (rawValue[0].length > 0 && rawValue[1].length > 0 && rawValue[2].length > 0)){
					entered.push(rawValue[2] + '-' + rawValue[1] + '-' + rawValue[0]);
				}

			}else if (question.type.value == 'external-widget') {
				entered = cc_Renderer.applyExternalWidgetGetEnteredFunction(question);

			}else{
				var rawValue = jField.getValue();

				if (rawValue && rawValue != '') {
					entered = rawValue.split(cc_Config.fieldDelimiter);
				}else{
					entered = [];
				}
			}
		}

		return entered; // null can never be retruned
	};

	cc_Renderer.flashQuestions = function (questions) {
		cc_Util.invokeOnElements(questions, function(){
			var questionContent = $('[cc-panel=' + this.id + ']:visible .questionContent');

			if(questionContent){
				cc_UI.flash(questionContent, 2, 600);
			}
		});

	};

	cc_Renderer.flashErrors = function () {
		cc_UI.flash($('.warningIcon, .errorIcon, .errorText'), 1, 600);
	};

	cc_Renderer.toRequestData = function(allowFindingsGeneration, includeAllFields){
		return {
			environment: cc_Config.environment,
			rulebookName : cc_Config.rulebookName,
			rulebookVersion : cc_Config.rulebookVersion,
			applicationId : cc_Config.applicationId,
			workflowName : cc_Config.workflowName,
			answeredQuestions : cc_Util.stringify(cc_Renderer.dettachQuestions(includeAllFields), cc_Config.uploadCompression.answeredQuestions),
			interactionState : JSON.stringify(cc_Model.interactionState),
			allowFindingsGeneration : allowFindingsGeneration
		};
	};

	cc_Renderer.hasFilesToUpload = function () {
		var hasFilesToUpload = false;

		$.each($('input[type=file]:visible'), function(){
			var questionId = $(this).attr('cc-field');

			// if there is a value then it means the user has selected a file but not pressed upload
			// note: the value will be
			if(questionId && $(this).getValue()){
				hasFilesToUpload = true;
			}
		});

		return hasFilesToUpload;
	};

	// override the default jquery autocomplete menu behaviour.
	// a rendered cloudcase autocomplete question menu should only be as wide as its input.
	// this is to provide a better responsive experience
	var existingAutocompleteResizeMenuFunction = jQuery.ui.autocomplete.prototype._resizeMenu;
	jQuery.ui.autocomplete.prototype._resizeMenu = function () {
		if($(this.menu.element).hasClass('cloudcase-form-autocomplete') === true){
			// make the width of the dropdown the same as the input field (inteview form questions only)
			var ul = this.menu.element;
			ul.outerWidth(this.element.outerWidth());
		}else{
			// or apply default behaviour where the dropdown is a wide as the largest menu item
			existingAutocompleteResizeMenuFunction.apply(this);
		}
	};

	cc_Renderer.hasButtonGroupStyle = function (question) {
		var hasButtonStyle = false;

		if (question && question.properties) {
			for (var i = 0; i < question.properties.length; i++) {
				if (question.properties[i].id === 'Style' && question.properties[i].value === 'ButtonGroup') {
					return true;
				}
			}
		}
		return hasButtonStyle;
	};

	// Get the whole page navigator
	cc_Renderer.getPageNavigatorSelector = function() {
		return '[id=cloudcase-page-navigator-unrestricted], [id=cloudcase-page-navigator-restricted]';
	}

	cc_Renderer.getPageNavigatorSelectorUnrestricted = function() {
		return "[id=cloudcase-page-navigator-unrestricted]";
	}

	cc_Renderer.getPageNavigatorSelectorRestricted = function() {
		return "[id=cloudcase-page-navigator-restricted]";
	}

	// Get an individual page navigator item
	cc_Renderer.getPageNavigatorItemSelector = function (pageId) {
		return '.page_navigator_item[cc-page-id=' + cc_Util.toWebSafeId(pageId) + ']';
	};

	// Get a collection of page navigator items by their group
	cc_Renderer.getPageNavigatorItemSelectorByGroup = function(groupId) {
		return '.page_navigator_item[cc-page-group-id=' + cc_Util.toWebSafeId(groupId) + ']';
	}

	// Get the container around the collection of page navigator items, this includes the page group navigator item
	cc_Renderer.getPageGroupNavigatorSelector = function(groupId) {
		return '.page_group_navigator[cc-page-group-id=' + cc_Util.toWebSafeId(groupId) + ']';
	}

	// Get the page group navigator item
	cc_Renderer.getPageGroupNavigatorItemSelector = function(groupId) {
		return '.page_group_navigator_item[cc-page-group-id=' + cc_Util.toWebSafeId(groupId) + ']';
	}

	cc_Renderer.unrenderNestedPages = function(navigator) {
		var nestedPages = navigator.find("ul");
		// remove the page group parents
		nestedPages.find("li.page_group_navigator_item").remove();
		// unnest page groups
		nestedPages.find("li").unwrap();
	};

	cc_Renderer.markPageGroupsInDOM = function(nestedPages, prefix) {
		prefix = (prefix === undefined) ? [] : prefix;
		Object.entries(nestedPages).forEach(function([group, pages]) {
			if (group === 'default') {
				pages.forEach(function(page) {
					var pageNavigatorItemDOM = $(cc_Renderer.getPageNavigatorItemSelector(page.id));
					if (prefix.length > 0) {
						pageNavigatorItemDOM.attr('cc-page-group-id', prefix.join(""));
						pageNavigatorItemDOM.addClass('subpage');
					}
				});
			} else {
				cc_Renderer.markPageGroupsInDOM(pages, prefix.concat([cc_Util.toWebSafeId(group)]));
			}
		})
	}

	cc_Renderer.renderPageGroups = function(pages, pageNavigators) {
		cc_Renderer.markPageGroupsInDOM(pages);
		var pageGroupIds = Object.keys(pages).filter(function(pageGroup) {return pageGroup !== 'default'});
		pageNavigators.each(function() {
			var pageNavigator = $(this);
			pageGroupIds.forEach(function(pageGroupId) {
				var pageGroupDOM = pageNavigator.find(cc_Renderer.getPageNavigatorItemSelectorByGroup(pageGroupId));
				pageGroupDOM.wrapAll("<ul class='page_group_navigator'>");
				pageGroupDOM.parent().attr("cc-page-group-id", cc_Util.toWebSafeId(pageGroupId));
				pageGroupDOM.parent().prepend(cc_View.createPageGroupNavigatorItem(pageGroupId, pageNavigator));
				cc_Renderer.applyPageGroupFolding(pageGroupId, pageNavigator);
			});
		});
	}

	cc_Renderer.collapsePageGroup = function (pageGroupItemDOM, pageGroupDOM) {
		pageGroupItemDOM.removeClass("expanded");
		pageGroupDOM.hide();
		pageGroupItemDOM.find(".chevron").empty().append(cc_Icon.chevronDownCircledIcon());
	}

	cc_Renderer.expandPageGroup = function (pageGroupItemDOM, pageGroupDOM) {
		pageGroupItemDOM.addClass("expanded");
		pageGroupDOM.show();
		pageGroupItemDOM.find(".chevron").empty().append(cc_Icon.chevronUpCircledIcon());
	}

	cc_Renderer.applyPageGroupFolding = function(pageGroupId, pageNavigator) {
		var pageGroupDOM = pageNavigator.find(cc_Renderer.getPageNavigatorItemSelectorByGroup(pageGroupId));
		var pageGroupItemDOM = pageNavigator.find(cc_Renderer.getPageGroupNavigatorItemSelector(pageGroupId));
		if (cc_UI.pageSelectedWithinPageGroup(pageGroupId, pageNavigator)) {
			cc_Renderer.expandPageGroup(pageGroupItemDOM, pageGroupDOM);
		} else {
			cc_Renderer.collapsePageGroup(pageGroupItemDOM, pageGroupDOM);
		}

		$(pageGroupItemDOM).on("click", function() {
			if ($(pageGroupItemDOM).hasClass("expanded")) {
				cc_Renderer.collapsePageGroup(pageGroupItemDOM, pageGroupDOM);
			} else {
				// Collapse all other page groups before opening this one
				$(cc_Renderer.getPageNavigatorSelector()).children('ul').each(function(index, pageGroup) {
					cc_Renderer.collapsePageGroup($(pageGroup).find('li').filter(':first'), $(pageGroup).find('li').not(':first'));
				});
				cc_Renderer.expandPageGroup(pageGroupItemDOM, pageGroupDOM);
			}
		});
	}

	cc_Renderer.enablePageFolding = function() {
		cc_Renderer.unrenderNestedPages($(cc_Renderer.getPageNavigatorSelector()));

		var filterByRestricted = function(restricted) {
			return function(acc, [key, pageGroup]) {
				if (key === "default") {
					acc["default"] = pageGroup.filter(function(page) {
						return page.restricted === restricted;
					})
				} else {
					acc[key] = Object.entries(pageGroup).reduce(filterByRestricted(restricted), {});
				}
				return acc;
			}
		}
		var unrestrictedPages = Object.entries(cc_Model.pageGroupsMap).reduce(filterByRestricted(false), {});
		var pageNavigatorUnrestricted = $(cc_Renderer.getPageNavigatorSelectorUnrestricted());

		var restrictedPages = Object.entries(cc_Model.pageGroupsMap).reduce(filterByRestricted(true), {});
		var pageNavigatorRestricted = $(cc_Renderer.getPageNavigatorSelectorRestricted());

		cc_Renderer.renderPageGroups(unrestrictedPages, pageNavigatorUnrestricted);
		cc_Renderer.renderPageGroups(restrictedPages, pageNavigatorRestricted);
	}
}());